import { Translations } from './types';

export const de: Translations = {
  sidebar: {
    welcome: 'Willkommen,',
    logout: 'Abmelden',
    closeMenu: 'Menü schließen',
    openMenu: 'Menü öffnen',
    menuItems: {
      'Homepage': 'Startseite',
      'Bacheca': 'Pinnwand',
      'Eventi': 'Veranstaltungen',
      'Pubblicità': 'Werbung',
      'Invia Messaggi': 'Nachrichten Senden',
      'Clienti': 'Kunden',
      'Matching': 'Matching',
      'Location': 'Standorte',
      'Team': 'Team',
      'Contabilità': 'Buchhaltung',
      'Agenzia Amore': 'Liebesagentur',
      'Dating Coach': 'Dating Coach',
      'Consulente d\'Immagine': 'Imageberater',
      'Messaggeria': 'Nachrichten',
      'Tavoli': 'Tische',
      'Messaggi': 'Nachrichten',
      'Consulenze': 'Beratungen',
      'Corsi per Single': 'Kurse für Singles',
      'Viaggi per Single': 'Reisen für Singles',
      'Marketing': 'Marketing',
      'Altri Eventi': 'Andere Veranstaltungen',
      'Speed Date': 'Speed Date',
      'Gestione Staff': 'Personalverwaltung',
    },
  },
  profile: {
    tabs: {
      profile: 'Profil',
      settings: 'Einstellungen',
      company: 'Unternehmen',
    },
    header: {
      name: 'Name',
      role: 'Rolle',
      city: 'Stadt',
      notDefined: 'Nicht definiert',
    },
    roles: {
      admin: 'Administrator',
      organizer: 'Organisator',
      pr: 'PR',
      collaboratore: 'Mitarbeiter',
    },
    form: {
      name: 'Name',
      email: 'Email',
      phone: 'Telefonnummer',
      city: 'Stadt',
      emailReadonly: 'Die Email kann nicht geändert werden',
      phonePlaceholder: '+49 123 456 7890',
      cityPlaceholder: 'Stadt eingeben',
      changePassword: 'Passwort Ändern',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Neues Passwort Bestätigen',
      newPasswordPlaceholder: 'Leer lassen, um nicht zu ändern',
      confirmPasswordPlaceholder: 'Neues Passwort wiederholen',
      saving: 'Wird gespeichert...',
      save: 'Änderungen Speichern',
    },
    settings: {
      notifications: 'Benachrichtigungen',
      emailNotifications: 'Email-Benachrichtigungen',
      pushNotifications: 'Push-Benachrichtigungen',
      eventReminders: 'Veranstaltungserinnerungen',
      security: 'Sicherheit',
      twoFactor: 'Zwei-Faktor-Authentifizierung',
      language: 'Sprache',
      languageDescription: 'Wählen Sie die Sprache der Administrationsoberfläche',
    },
    company: {
      title: 'Unternehmensprofil',
      companyName: 'Unternehmensname',
      email: 'Email',
      phone: 'Telefon',
    },
    messages: {
      passwordMismatch: 'Die Passwörter stimmen nicht überein',
      passwordTooShort: 'Das Passwort muss mindestens 6 Zeichen lang sein',
      updateSuccess: 'Profil erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren des Profils',
    },
  },
  homepage: {
    title: 'Startseite',
    loading: 'Wird geladen...',
    stats: {
      totalEvents: 'Veranstaltungen Gesamt',
      participants: 'Teilnehmer',
      locations: 'Standorte',
      matches: 'Matches',
      totalClients: 'Kunden Gesamt',
      totalRevenue: 'Gesamteinnahmen',
      showRevenue: 'Einnahmen anzeigen',
      hideRevenue: 'Einnahmen ausblenden',
    },
    recentEvents: 'STATISTIKEN LETZTE VERANSTALTUNGEN',
    upcomingEvents: 'NÄCHSTE VERANSTALTUNGEN ITALIEN',
    table: {
      eventName: 'Veranstaltungsname',
      ageRange: 'Altersgruppe',
      date: 'Datum',
      location: 'Standort',
      city: 'Stadt',
      participants: 'Teilnehmer',
      matches: 'Matches',
      menRevenue: 'Einnahmen Männer',
      womenRevenue: 'Einnahmen Frauen',
      total: 'Gesamt',
      men: 'M: ',
      women: 'F: ',
    },
    noEvents: 'Keine Veranstaltungen geplant',
    eventStatus: {
      soldOut: 'AUSVERKAUFT + WARTELISTE',
      almostFull: 'FAST VOLL',
      limitedSpots: 'BEGRENZTE PLÄTZE',
      scheduled: 'GEPLANT',
    },
  },
  login: {
    brand: 'FlashCrush',
    email: 'Email',
    password: 'Passwort',
    loggingIn: 'Anmeldung läuft...',
    logIn: 'Anmelden',
    register: 'Registrieren',
    forgotPassword: 'Passwort vergessen?',
    registrationTitle: 'Registrierung',
    registrationDescription: 'Erstellen Sie ein neues Konto, um an Veranstaltungen teilzunehmen.',
    fullName: 'Vollständiger Name',
    registering: 'Registrierung läuft...',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto? Anmelden',
    resetPasswordTitle: 'Passwort Wiederherstellen',
    resetPasswordDescription: 'Geben Sie Ihre Email ein, um Anweisungen zur Passwortwiederherstellung zu erhalten.',
    sending: 'Wird gesendet...',
    sendInstructions: 'Anweisungen senden',
    backToLogin: 'Zurück zum Login',
    resetEmailSent: 'Wenn die Email-Adresse existiert, erhalten Sie Anweisungen zum Zurücksetzen Ihres Passworts.',
    errors: {
      invalidCredentials: 'Ungültige Anmeldedaten. Bitte überprüfen Sie Email und Passwort und versuchen Sie es erneut.',
      emailNotConfirmed: 'Email nicht bestätigt. Überprüfen Sie Ihren Posteingang für den Bestätigungslink.',
      invalidEmailFormat: 'Ungültiges Email-Format. Bitte geben Sie eine gültige Email-Adresse ein.',
      genericLoginError: 'Beim Anmelden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
      registrationError: 'Fehler bei der Registrierung',
      resetPasswordError: 'Fehler bei der Passwortwiederherstellung',
    },
  },
  auth: {
    pendingApproval: 'Ihr Konto wartet auf die Genehmigung durch einen Administrator.',
    accountRejected: 'Ihr Konto wurde abgelehnt. Kontaktieren Sie den Administrator für weitere Informationen.',
    accountSuspended: 'Ihr Konto wurde gesperrt. Kontaktieren Sie den Administrator für weitere Informationen.',
    registrationComplete: 'Registrierung abgeschlossen! Ihr Konto wartet auf die Genehmigung durch einen Administrator. Sie erhalten eine Benachrichtigung, wenn Sie sich anmelden können.',
  },
  common: {
    loading: 'Wird geladen...',
    error: 'Fehler',
    close: 'Schließen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    search: 'Suchen',
    noResults: 'Keine Ergebnisse',
    back: 'Zurück',
    next: 'Weiter',
    hiddenAmount: '••••• €',
  },
};
